import { motion } from "framer-motion";
import { ShieldCheck, Check, MessageCircle } from "lucide-react";
import { useChat } from "@/context/ChatContext";

const EASE = [0.22, 1, 0.36, 1];

const DIFERENCIAIS = [
  "14 anos de experiência no mercado de consórcios",
  "Atendimento consultivo, com conhecimento de mercado",
  "Soluções personalizadas para cada objetivo e necessidade",
  "Relacionamentos sólidos e segurança em cada decisão",
];

export default function About() {
  const { openChat, waDefault } = useChat();

  return (
    <section id="sobre" className="scroll-mt-24 bg-slate-50 py-24 md:py-32" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-6 lg:grid-cols-12">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="relative mx-auto w-full max-w-md lg:col-span-5"
        >
          <div aria-hidden="true" className="absolute -inset-3 rounded-[2.5rem] border-2 border-brand-100" />
          <div className="relative overflow-hidden rounded-[2rem] shadow-2xl shadow-brand-900/10">
            <img
              src="/isabela.jpg"
              alt="Isabela Guedes, consultora de consórcios"
              className="w-full h-auto"
              loading="lazy"
              data-testid="isabela-photo"
            />
          </div>
          <div className="glass absolute -bottom-5 left-1/2 flex w-max -translate-x-1/2 items-center gap-2.5 rounded-2xl px-5 py-3">
            <ShieldCheck className="h-5 w-5 text-brand-600" />
            <span className="text-sm font-bold text-slate-800">Consultora autorizada Porto Seguro</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-600">Sobre a Isabela</p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Isabela Guedes
          </h2>
          <p className="mt-2 text-sm font-bold uppercase tracking-[0.14em] text-brand-600">
            Consultora de consórcios · Imóveis e veículos
          </p>

          <div className="mt-6 max-w-2xl space-y-4 text-base leading-relaxed text-slate-600">
            <p>
              Com <strong className="font-bold text-slate-900">14 anos de experiência</strong> no mercado de
              consórcios, construí uma trajetória pautada pela credibilidade, confiança e compromisso com meus
              clientes. Ao longo da minha carreira, desenvolvi ampla experiência em consórcios de imóveis,
              automóveis, motocicletas e serviços, oferecendo soluções personalizadas de acordo com os objetivos
              e as necessidades de cada cliente.
            </p>
            <p>
              Minha atuação é marcada pelo conhecimento de mercado, atendimento consultivo e dedicação em
              orientar pessoas na realização de seus projetos e conquistas. Mais do que oferecer consórcios,
              acredito na construção de relacionamentos sólidos, proporcionando segurança em cada decisão e
              apoio na transformação de planejamentos em oportunidades reais.
            </p>
          </div>
          <p className="mt-6 max-w-2xl font-display text-lg font-bold text-brand-600">
            Experiência, credibilidade e compromisso para ajudar você a conquistar seus objetivos.
          </p>

          <ul className="mt-8 grid max-w-2xl grid-cols-1 gap-3 sm:grid-cols-2">
            {DIFERENCIAIS.map((d) => (
              <li key={d} className="flex items-start gap-2.5 text-base font-semibold text-slate-700">
                <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-600/10 text-brand-600">
                  <Check className="h-3.5 w-3.5" />
                </span>
                {d}
              </li>
            ))}
          </ul>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <button
              data-testid="about-chat-button"
              onClick={() => openChat(null)}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-600 px-7 py-3.5 text-sm font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-brand-700 hover:shadow-lg"
            >
              <MessageCircle className="h-4 w-4" /> Falar com a Isabela
            </button>
            <a
              href={waDefault()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-whatsapp-button"
              className="inline-flex items-center justify-center rounded-full border-2 border-brand-600/15 bg-white px-7 py-3.5 text-sm font-bold text-brand-600 transition-all hover:-translate-y-0.5 hover:border-brand-600/40 hover:shadow-lg"
            >
              WhatsApp direto
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
